import { useState, useEffect } from "react";

const useLocalStorageState = (key: string, initialValue: any) => {
  const storedValue = localStorage.getItem(key);
  const [state, setState] = useState(() => {
    try {
      return storedValue ? JSON.parse(storedValue) : initialValue;
    } catch (error) {
      console.warn(`Failed to parse stored value for key "${key}"`, error);
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.warn(`Failed to store value for key "${key}"`, error);
    }
  }, [key, state]);

  return [state, setState];
};

export default useLocalStorageState;
